export const utahCountiesList = [
    'Beaver',
    'Box Elder',
    'Cache',
    'Carbon',
    'Daggett',
    'Davis',
    'Duchesne',
    'Emery',
    'Garfield',
    'Grand',
    'Iron',
    'Juab',
    'Kane',
    'Millard',
    'Morgan',
    'Piute',
    'Rich',
    'Salt Lake',
    'San Juan',
    'Sanpete',
    'Sevier',
    'Summit',
    'Tooele',
    'Uintah',
    'Utah',
    'Wasatch',
    'Washington',
    'Wayne',
    'Weber',
]